// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import SelectButton from "metabase/common/components/SelectButton/SelectButton";

export const DashboardPickerButton = styled(SelectButton)`
  min-width: 400px;
`;
